require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.is-integer");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.create");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

/*!
 * 
 *   react-simple-keyboard v1.26.6
 *   https://github.com/hodgef/react-simple-keyboard
 * 
 *   Copyright (c) Francisco Hodge (https://github.com/hodgef)
 * 
 *   This source code is licensed under the MIT license found in the
 *   LICENSE file in the root directory of this source tree.
 *   
 */
!function (e, t) {
  "object" === typeof exports && "object" === typeof module ? module.exports = t() : "function" === typeof define && define.amd ? define("ReactSimpleKeyboard", [], t) : "object" === typeof exports ? exports.ReactSimpleKeyboard = t() : e.ReactSimpleKeyboard = t();
}(window, function () {
  return function (e) {
    var t = {};

    function __webpack_require__(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, __webpack_require__), o.l = !0, o.exports;
    }

    return __webpack_require__.m = e, __webpack_require__.c = t, __webpack_require__.d = function (e, t, n) {
      __webpack_require__.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, __webpack_require__.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__.t = function (e, t) {
      if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;
      if (4 & t && "object" === typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (__webpack_require__.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        __webpack_require__.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, __webpack_require__.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return __webpack_require__.d(t, "a", t), t;
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 4);
  }([function (e, t, n) {
    "use strict";

    e.exports = n(5);
  }, function (e, t) {
    function _typeof2(e) {
      return (_typeof2 = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function _typeof(t) {
      return "function" === typeof Symbol && "symbol" === _typeof2(Symbol.iterator) ? e.exports = _typeof = function _typeof(e) {
        return _typeof2(e);
      } : e.exports = _typeof = function _typeof(e) {
        return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof2(e);
      }, _typeof(t);
    }

    e.exports = _typeof;
  }, function (e, t, n) {
    e.exports = n(7)();
  }, function (e, t, n) {
    (function (e) {
      var o,
          r,
          i,
          s,
          a = n(1);
      window, s = function s() {
        return function (e) {
          var t = {};

          function __webpack_require__(n) {
            if (t[n]) return t[n].exports;
            var o = t[n] = {
              i: n,
              l: !1,
              exports: {}
            };
            return e[n].call(o.exports, o, o.exports, __webpack_require__), o.l = !0, o.exports;
          }

          return __webpack_require__.m = e, __webpack_require__.c = t, __webpack_require__.d = function (e, t, n) {
            __webpack_require__.o(e, t) || Object.defineProperty(e, t, {
              enumerable: !0,
              get: n
            });
          }, __webpack_require__.r = function (e) {
            "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
              value: "Module"
            }), Object.defineProperty(e, "__esModule", {
              value: !0
            });
          }, __webpack_require__.t = function (e, t) {
            if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;
            if (4 & t && "object" === a(e) && e && e.__esModule) return e;
            var n = Object.create(null);
            if (__webpack_require__.r(n), Object.defineProperty(n, "default", {
              enumerable: !0,
              value: e
            }), 2 & t && "string" != typeof e) for (var o in e) {
              __webpack_require__.d(n, o, function (t) {
                return e[t];
              }.bind(null, o));
            }
            return n;
          }, __webpack_require__.n = function (e) {
            var t = e && e.__esModule ? function () {
              return e["default"];
            } : function () {
              return e;
            };
            return __webpack_require__.d(t, "a", t), t;
          }, __webpack_require__.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
          }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 0);
        }([function (e, t, n) {
          e.exports = n(2);
        }, function (e, t, n) {}, function (e, t, n) {
          "use strict";

          function _typeof(e) {
            return (_typeof = "function" === typeof Symbol && "symbol" === a(Symbol.iterator) ? function (e) {
              return a(e);
            } : function (e) {
              return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : a(e);
            })(e);
          }

          function _defineProperties(e, t) {
            for (var n = 0; n < t.length; n++) {
              var o = t[n];
              o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
            }
          }

          n.r(t), n(1);

          var o = function () {
            function Utilities(e) {
              var t = e.getOptions,
                  n = e.getCaretPosition,
                  o = e.dispatch;
              !function (e, t) {
                if (!(e instanceof Utilities)) throw new TypeError("Cannot call a class as a function");
              }(this), this.getOptions = t, this.getCaretPosition = n, this.dispatch = o, Utilities.bindMethods(Utilities, this);
            }

            var e, t, n;
            return e = Utilities, n = [{
              key: "bindMethods",
              value: function value(e, t) {
                var n = !0,
                    o = !1,
                    r = void 0;

                try {
                  for (var i, s = Object.getOwnPropertyNames(e.prototype)[Symbol.iterator](); !(n = (i = s.next()).done); n = !0) {
                    var a = i.value;
                    "constructor" === a || "bindMethods" === a || (t[a] = t[a].bind(t));
                  }
                } catch (u) {
                  o = !0, r = u;
                } finally {
                  try {
                    n || null == s["return"] || s["return"]();
                  } finally {
                    if (o) throw r;
                  }
                }
              }
            }], (t = [{
              key: "getButtonClass",
              value: function value(e) {
                var t = e.includes("{") && e.includes("}") && "{//}" !== e ? "functionBtn" : "standardBtn",
                    n = e.replace("{", "").replace("}", ""),
                    o = "";
                return "standardBtn" !== t && (o = " hg-button-".concat(n)), "hg-".concat(t).concat(o);
              }
            }, {
              key: "getDefaultDiplay",
              value: function value() {
                return {
                  "{bksp}": "backspace",
                  "{backspace}": "backspace",
                  "{enter}": "< enter",
                  "{shift}": "shift",
                  "{shiftleft}": "shift",
                  "{shiftright}": "shift",
                  "{alt}": "alt",
                  "{s}": "shift",
                  "{tab}": "tab",
                  "{lock}": "caps",
                  "{capslock}": "caps",
                  "{accept}": "Submit",
                  "{space}": " ",
                  "{//}": " ",
                  "{esc}": "esc",
                  "{escape}": "esc",
                  "{f1}": "f1",
                  "{f2}": "f2",
                  "{f3}": "f3",
                  "{f4}": "f4",
                  "{f5}": "f5",
                  "{f6}": "f6",
                  "{f7}": "f7",
                  "{f8}": "f8",
                  "{f9}": "f9",
                  "{f10}": "f10",
                  "{f11}": "f11",
                  "{f12}": "f12",
                  "{numpaddivide}": "/",
                  "{numlock}": "lock",
                  "{arrowup}": "\u2191",
                  "{arrowleft}": "\u2190",
                  "{arrowdown}": "\u2193",
                  "{arrowright}": "\u2192",
                  "{prtscr}": "print",
                  "{scrolllock}": "scroll",
                  "{pause}": "pause",
                  "{insert}": "ins",
                  "{home}": "home",
                  "{pageup}": "up",
                  "{delete}": "del",
                  "{end}": "end",
                  "{pagedown}": "down",
                  "{numpadmultiply}": "*",
                  "{numpadsubtract}": "-",
                  "{numpadadd}": "+",
                  "{numpadenter}": "enter",
                  "{period}": ".",
                  "{numpaddecimal}": ".",
                  "{numpad0}": "0",
                  "{numpad1}": "1",
                  "{numpad2}": "2",
                  "{numpad3}": "3",
                  "{numpad4}": "4",
                  "{numpad5}": "5",
                  "{numpad6}": "6",
                  "{numpad7}": "7",
                  "{numpad8}": "8",
                  "{numpad9}": "9"
                };
              }
            }, {
              key: "getButtonDisplayName",
              value: function value(e, t, n) {
                return (t = n ? Object.assign({}, this.getDefaultDiplay(), t) : t || this.getDefaultDiplay())[e] || e;
              }
            }, {
              key: "getUpdatedInput",
              value: function value(e, t, n, o) {
                var r = this.getOptions(),
                    i = t;
                return ("{bksp}" === e || "{backspace}" === e) && i.length > 0 ? i = this.removeAt(i, n, o) : "{space}" === e ? i = this.addStringAt(i, " ", n, o) : "{tab}" !== e || "boolean" === typeof r.tabCharOnTab && !1 === r.tabCharOnTab ? "{enter}" !== e && "{numpadenter}" !== e || !r.newLineOnEnter ? e.includes("numpad") && Number.isInteger(Number(e[e.length - 2])) ? i = this.addStringAt(i, e[e.length - 2], n, o) : "{numpaddivide}" === e ? i = this.addStringAt(i, "/", n, o) : "{numpadmultiply}" === e ? i = this.addStringAt(i, "*", n, o) : "{numpadsubtract}" === e ? i = this.addStringAt(i, "-", n, o) : "{numpadadd}" === e ? i = this.addStringAt(i, "+", n, o) : "{numpaddecimal}" === e ? i = this.addStringAt(i, ".", n, o) : "{" === e || "}" === e ? i = this.addStringAt(i, e, n, o) : e.includes("{") || e.includes("}") || (i = this.addStringAt(i, e, n, o)) : i = this.addStringAt(i, "\n", n, o) : i = this.addStringAt(i, "\t", n, o), i;
              }
            }, {
              key: "updateCaretPos",
              value: function value(e, t) {
                var n = this.updateCaretPosAction(e, t);
                this.dispatch(function (e) {
                  e.caretPosition = n;
                });
              }
            }, {
              key: "updateCaretPosAction",
              value: function value(e, t) {
                var n = this.getOptions(),
                    o = this.getCaretPosition();
                return t ? o > 0 && (o -= e) : o += e, n.debug && console.log("Caret at:", o, "(".concat(this.keyboardDOMClass, ")")), o;
              }
            }, {
              key: "addStringAt",
              value: function value(e, t, n, o) {
                var r;
                return n || 0 === n ? (r = [e.slice(0, n), t, e.slice(n)].join(""), this.isMaxLengthReached() || o && this.updateCaretPos(t.length)) : r = e + t, r;
              }
            }, {
              key: "removeAt",
              value: function value(e, t, n) {
                var o;
                if (0 === this.getCaretPosition()) return e;
                var r = /([\uD800-\uDBFF][\uDC00-\uDFFF])/g;
                return t && t >= 0 ? e.substring(t - 2, t).match(r) ? (o = e.substr(0, t - 2) + e.substr(t), n && this.updateCaretPos(2, !0)) : (o = e.substr(0, t - 1) + e.substr(t), n && this.updateCaretPos(1, !0)) : e.slice(-2).match(r) ? (o = e.slice(0, -2), n && this.updateCaretPos(2, !0)) : (o = e.slice(0, -1), n && this.updateCaretPos(1, !0)), o;
              }
            }, {
              key: "handleMaxLength",
              value: function value(e, t) {
                var n = this.getOptions(),
                    o = n.maxLength,
                    r = e[n.inputName],
                    i = r.length === o;
                if (t.length <= r.length) return !1;
                if (Number.isInteger(o)) return n.debug && console.log("maxLength (num) reached:", i), i ? (this.maxLengthReached = !0, !0) : (this.maxLengthReached = !1, !1);

                if ("object" === _typeof(o)) {
                  var s = r.length === o[n.inputName];
                  return n.debug && console.log("maxLength (obj) reached:", s), s ? (this.maxLengthReached = !0, !0) : (this.maxLengthReached = !1, !1);
                }
              }
            }, {
              key: "isMaxLengthReached",
              value: function value() {
                return Boolean(this.maxLengthReached);
              }
            }, {
              key: "isTouchDevice",
              value: function value() {
                return "ontouchstart" in window || navigator.maxTouchPoints;
              }
            }, {
              key: "pointerEventsSupported",
              value: function value() {
                return window.PointerEvent;
              }
            }, {
              key: "camelCase",
              value: function value(e) {
                return !!e && e.toLowerCase().trim().split(/[.\-_\s]/g).reduce(function (e, t) {
                  return t.length ? e + t[0].toUpperCase() + t.slice(1) : e;
                });
              }
            }]) && _defineProperties(e.prototype, t), n && _defineProperties(e, n), Utilities;
          }();

          function PhysicalKeyboard_defineProperties(e, t) {
            for (var n = 0; n < t.length; n++) {
              var o = t[n];
              o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
            }
          }

          var r = function () {
            function PhysicalKeyboard(e) {
              var t = e.dispatch,
                  n = e.getOptions;
              !function (e, t) {
                if (!(e instanceof PhysicalKeyboard)) throw new TypeError("Cannot call a class as a function");
              }(this), this.dispatch = t, this.getOptions = n, o.bindMethods(PhysicalKeyboard, this);
            }

            var e, t;
            return e = PhysicalKeyboard, (t = [{
              key: "handleHighlightKeyDown",
              value: function value(e) {
                var t = this.getOptions(),
                    n = this.getSimpleKeyboardLayoutKey(e);
                this.dispatch(function (e) {
                  var o = e.getButtonElement(n) || e.getButtonElement("{".concat(n, "}"));
                  o && (o.style.backgroundColor = t.physicalKeyboardHighlightBgColor || "#9ab4d0", o.style.color = t.physicalKeyboardHighlightTextColor || "white");
                });
              }
            }, {
              key: "handleHighlightKeyUp",
              value: function value(e) {
                var t = this.getSimpleKeyboardLayoutKey(e);
                this.dispatch(function (e) {
                  var n = e.getButtonElement(t) || e.getButtonElement("{".concat(t, "}"));
                  n && n.removeAttribute && n.removeAttribute("style");
                });
              }
            }, {
              key: "getSimpleKeyboardLayoutKey",
              value: function value(e) {
                var t;
                return ((t = e.code.includes("Numpad") || e.code.includes("Shift") || e.code.includes("Space") || e.code.includes("Backspace") || e.code.includes("Control") || e.code.includes("Alt") || e.code.includes("Meta") ? e.code : e.key) !== t.toUpperCase() || "F" === e.code[0] && Number.isInteger(Number(e.code[1])) && e.code.length <= 3) && (t = t.toLowerCase()), t;
              }
            }]) && PhysicalKeyboard_defineProperties(e.prototype, t), PhysicalKeyboard;
          }();

          function KeyboardLayout_defineProperties(e, t) {
            for (var n = 0; n < t.length; n++) {
              var o = t[n];
              o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
            }
          }

          var i = function () {
            function KeyboardLayout() {
              !function (e, t) {
                if (!(e instanceof KeyboardLayout)) throw new TypeError("Cannot call a class as a function");
              }(this);
            }

            var e, t;
            return e = KeyboardLayout, (t = [{
              key: "getDefaultLayout",
              value: function value() {
                return {
                  "default": ["` 1 2 3 4 5 6 7 8 9 0 - = {bksp}", "{tab} q w e r t y u i o p [ ] \\", "{lock} a s d f g h j k l ; ' {enter}", "{shift} z x c v b n m , . / {shift}", ".com @ {space}"],
                  shift: ["~ ! @ # $ % ^ & * ( ) _ + {bksp}", "{tab} Q W E R T Y U I O P { } |", '{lock} A S D F G H J K L : " {enter}', "{shift} Z X C V B N M < > ? {shift}", ".com @ {space}"]
                };
              }
            }]) && KeyboardLayout_defineProperties(e, t), KeyboardLayout;
          }();

          function _toConsumableArray(e) {
            return function (e) {
              if (Array.isArray(e)) {
                for (var t = 0, n = new Array(e.length); t < e.length; t++) {
                  n[t] = e[t];
                }

                return n;
              }
            }(e) || function (e) {
              if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
            }(e) || function () {
              throw new TypeError("Invalid attempt to spread non-iterable instance");
            }();
          }

          function Keyboard_typeof(e) {
            return (Keyboard_typeof = "function" === typeof Symbol && "symbol" === a(Symbol.iterator) ? function (e) {
              return a(e);
            } : function (e) {
              return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : a(e);
            })(e);
          }

          function Keyboard_defineProperties(e, t) {
            for (var n = 0; n < t.length; n++) {
              var o = t[n];
              o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
            }
          }

          function _defineProperty(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = n, e;
          }

          var s = function () {
            function SimpleKeyboard() {
              var e = this;
              !function (e, t) {
                if (!(e instanceof SimpleKeyboard)) throw new TypeError("Cannot call a class as a function");
              }(this), _defineProperty(this, "getOptions", function () {
                return e.options;
              }), _defineProperty(this, "getCaretPosition", function () {
                return e.caretPosition;
              }), _defineProperty(this, "registerModule", function (t, n) {
                e.modules[t] || (e.modules[t] = {}), n(e.modules[t]);
              });
              var t = "string" === typeof (arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 0 ? void 0 : arguments[0] : ".simple-keyboard",
                  n = "object" === Keyboard_typeof(arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 0 ? void 0 : arguments[0] : arguments.length <= 1 ? void 0 : arguments[1];
              if (n || (n = {}), this.utilities = new o({
                getOptions: this.getOptions,
                getCaretPosition: this.getCaretPosition,
                dispatch: this.dispatch
              }), this.caretPosition = null, this.keyboardDOM = document.querySelector(t), this.options = n, this.options.layoutName = this.options.layoutName || "default", this.options.theme = this.options.theme || "hg-theme-default", this.options.inputName = this.options.inputName || "default", this.options.preventMouseDownDefault = this.options.preventMouseDownDefault || !1, this.keyboardPluginClasses = "", o.bindMethods(SimpleKeyboard, this), this.input = {}, this.input[this.options.inputName] = "", this.keyboardDOMClass = t.split(".").join(""), this.buttonElements = {}, window.SimpleKeyboardInstances || (window.SimpleKeyboardInstances = {}), window.SimpleKeyboardInstances[this.utilities.camelCase(this.keyboardDOMClass)] = this, this.allKeyboardInstances = window.SimpleKeyboardInstances, this.currentInstanceName = this.utilities.camelCase(this.keyboardDOMClass), this.keyboardInstanceNames = Object.keys(window.SimpleKeyboardInstances), this.isFirstKeyboardInstance = this.keyboardInstanceNames[0] === this.currentInstanceName, this.physicalKeyboard = new r({
                dispatch: this.dispatch,
                getOptions: this.getOptions
              }), !this.keyboardDOM) throw console.warn('"'.concat(t, '" was not found in the DOM.')), new Error("KEYBOARD_DOM_ERROR");
              this.render(), this.modules = {}, this.loadModules();
            }

            var e, t;
            return e = SimpleKeyboard, (t = [{
              key: "handleButtonClicked",
              value: function value(e) {
                var t = this.options.debug;
                if ("{//}" === e) return !1;
                "function" === typeof this.options.onKeyPress && this.options.onKeyPress(e), this.input[this.options.inputName] || (this.input[this.options.inputName] = "");
                var n = this.utilities.getUpdatedInput(e, this.input[this.options.inputName], this.caretPosition);

                if (this.input[this.options.inputName] !== n && (!this.options.inputPattern || this.options.inputPattern && this.inputPatternIsValid(n))) {
                  if (this.options.maxLength && this.utilities.handleMaxLength(this.input, n)) return !1;
                  this.input[this.options.inputName] = this.utilities.getUpdatedInput(e, this.input[this.options.inputName], this.caretPosition, !0), t && console.log("Input changed:", this.input), this.options.syncInstanceInputs && this.syncInstanceInputs(this.input), "function" === typeof this.options.onChange && this.options.onChange(this.input[this.options.inputName]), "function" === typeof this.options.onChangeAll && this.options.onChangeAll(this.input);
                }

                t && console.log("Key pressed:", e);
              }
            }, {
              key: "handleButtonMouseDown",
              value: function value(e, t) {
                var n = this;
                this.options.preventMouseDownDefault && t.preventDefault(), this.options.stopMouseDownPropagation && t.stopPropagation(), this.isMouseHold = !0, this.holdInteractionTimeout && clearTimeout(this.holdInteractionTimeout), this.holdTimeout && clearTimeout(this.holdTimeout), this.options.disableButtonHold || (this.holdTimeout = setTimeout(function () {
                  !n.isMouseHold || (e.includes("{") || e.includes("}")) && "{delete}" !== e && "{backspace}" !== e && "{bksp}" !== e && "{space}" !== e && "{tab}" !== e || (n.options.debug && console.log("Button held:", e), n.handleButtonHold(e, t)), clearTimeout(n.holdTimeout);
                }, 500));
              }
            }, {
              key: "handleButtonMouseUp",
              value: function value(e) {
                this.isMouseHold = !1, this.holdInteractionTimeout && clearTimeout(this.holdInteractionTimeout), e && "function" === typeof this.options.onKeyReleased && this.options.onKeyReleased(e);
              }
            }, {
              key: "handleButtonHold",
              value: function value(e) {
                var t = this;
                this.holdInteractionTimeout && clearTimeout(this.holdInteractionTimeout), this.holdInteractionTimeout = setTimeout(function () {
                  t.isMouseHold ? (t.handleButtonClicked(e), t.handleButtonHold(e)) : clearTimeout(t.holdInteractionTimeout);
                }, 100);
              }
            }, {
              key: "syncInstanceInputs",
              value: function value() {
                var e = this;
                this.dispatch(function (t) {
                  t.replaceInput(e.input), t.caretPosition = e.caretPosition;
                });
              }
            }, {
              key: "clearInput",
              value: function value(e) {
                e = e || this.options.inputName, this.input[e] = "", this.caretPosition = 0, this.options.syncInstanceInputs && this.syncInstanceInputs(this.input);
              }
            }, {
              key: "getInput",
              value: function value(e) {
                return e = e || this.options.inputName, this.options.syncInstanceInputs && this.syncInstanceInputs(this.input), this.input[e];
              }
            }, {
              key: "setInput",
              value: function value(e, t) {
                t = t || this.options.inputName, this.input[t] = e, this.options.syncInstanceInputs && this.syncInstanceInputs(this.input);
              }
            }, {
              key: "replaceInput",
              value: function value(e) {
                this.input = e;
              }
            }, {
              key: "setOptions",
              value: function value(e) {
                e = e || {}, this.options = Object.assign(this.options, e), this.onSetOptions(e), this.render();
              }
            }, {
              key: "onSetOptions",
              value: function value(e) {
                e.inputName && (this.options.debug && console.log("inputName changed. caretPosition reset."), this.caretPosition = null);
              }
            }, {
              key: "clear",
              value: function value() {
                this.keyboardDOM.innerHTML = "", this.keyboardDOM.className = this.keyboardDOMClass, this.buttonElements = {};
              }
            }, {
              key: "dispatch",
              value: function value(e) {
                if (!window.SimpleKeyboardInstances) throw console.warn("SimpleKeyboardInstances is not defined. Dispatch cannot be called."), new Error("INSTANCES_VAR_ERROR");
                return Object.keys(window.SimpleKeyboardInstances).forEach(function (t) {
                  e(window.SimpleKeyboardInstances[t], t);
                });
              }
            }, {
              key: "addButtonTheme",
              value: function value(e, t) {
                var n = this;
                if (!t || !e) return !1;
                e.split(" ").forEach(function (o) {
                  t.split(" ").forEach(function (t) {
                    n.options.buttonTheme || (n.options.buttonTheme = []);
                    var r = !1;
                    n.options.buttonTheme.map(function (e) {
                      if (e["class"].split(" ").includes(t)) {
                        r = !0;
                        var n = e.buttons.split(" ");
                        n.includes(o) || (r = !0, n.push(o), e.buttons = n.join(" "));
                      }

                      return e;
                    }), r || n.options.buttonTheme.push({
                      "class": t,
                      buttons: e
                    });
                  });
                }), this.render();
              }
            }, {
              key: "removeButtonTheme",
              value: function value(e, t) {
                var n = this;
                if (!e && !t) return this.options.buttonTheme = [], this.render(), !1;
                e && Array.isArray(this.options.buttonTheme) && this.options.buttonTheme.length && (e.split(" ").forEach(function (e, o) {
                  n.options.buttonTheme.map(function (o, r) {
                    if (t && t.includes(o["class"]) || !t) {
                      var i = o.buttons.split(" ").filter(function (t) {
                        return t !== e;
                      });
                      i.length ? o.buttons = i.join(" ") : (n.options.buttonTheme.splice(r, 1), o = null);
                    }

                    return o;
                  });
                }), this.render());
              }
            }, {
              key: "getButtonElement",
              value: function value(e) {
                var t,
                    n = this.buttonElements[e];
                return n && (t = n.length > 1 ? n : n[0]), t;
              }
            }, {
              key: "inputPatternIsValid",
              value: function value(e) {
                var t,
                    n = this.options.inputPattern;

                if ((t = n instanceof RegExp ? n : n[this.options.inputName]) && e) {
                  var o = t.test(e);
                  return this.options.debug && console.log('inputPattern ("'.concat(t, '"): ').concat(o ? "passed" : "did not pass!")), o;
                }

                return !0;
              }
            }, {
              key: "setEventListeners",
              value: function value() {
                !this.isFirstKeyboardInstance && this.allKeyboardInstances || (this.options.debug && console.log("Caret handling started (".concat(this.keyboardDOMClass, ")")), document.addEventListener("keyup", this.handleKeyUp), document.addEventListener("keydown", this.handleKeyDown), document.addEventListener("mouseup", this.handleMouseUp), document.addEventListener("touchend", this.handleTouchEnd));
              }
            }, {
              key: "handleKeyUp",
              value: function value(e) {
                this.caretEventHandler(e), this.options.physicalKeyboardHighlight && this.physicalKeyboard.handleHighlightKeyUp(e);
              }
            }, {
              key: "handleKeyDown",
              value: function value(e) {
                this.options.physicalKeyboardHighlight && this.physicalKeyboard.handleHighlightKeyDown(e);
              }
            }, {
              key: "handleMouseUp",
              value: function value(e) {
                this.caretEventHandler(e);
              }
            }, {
              key: "handleTouchEnd",
              value: function value(e) {
                this.caretEventHandler(e);
              }
            }, {
              key: "caretEventHandler",
              value: function value(e) {
                var t;
                e.target.tagName && (t = e.target.tagName.toLowerCase()), this.dispatch(function (n) {
                  n.isMouseHold && (n.isMouseHold = !1), "textarea" !== t && "input" !== t || n.options.disableCaretPositioning ? n.options.disableCaretPositioning && (n.caretPosition = null) : (n.caretPosition = e.target.selectionStart, n.options.debug && console.log("Caret at: ", e.target.selectionStart, e.target.tagName.toLowerCase(), "(".concat(n.keyboardDOMClass, ")")));
                });
              }
            }, {
              key: "destroy",
              value: function value() {
                document.removeEventListener("keyup", this.handleKeyUp), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("touchend", this.handleTouchEnd), this.clear();
              }
            }, {
              key: "getButtonThemeClasses",
              value: function value(e) {
                var t = this.options.buttonTheme,
                    n = [];
                return Array.isArray(t) && t.forEach(function (t) {
                  if (t["class"] && "string" === typeof t["class"] && t.buttons && "string" === typeof t.buttons) {
                    var o = t["class"].split(" ");
                    t.buttons.split(" ").includes(e) && (n = [].concat(_toConsumableArray(n), _toConsumableArray(o)));
                  } else console.warn('Incorrect "buttonTheme". Please check the documentation.', t);
                }), n;
              }
            }, {
              key: "setDOMButtonAttributes",
              value: function value(e, t) {
                var n = this.options.buttonAttributes;
                Array.isArray(n) && n.forEach(function (n) {
                  n.attribute && "string" === typeof n.attribute && n.value && "string" === typeof n.value && n.buttons && "string" === typeof n.buttons ? n.buttons.split(" ").includes(e) && t(n.attribute, n.value) : console.warn('Incorrect "buttonAttributes". Please check the documentation.', n);
                });
              }
            }, {
              key: "onTouchDeviceDetected",
              value: function value() {
                this.processAutoTouchEvents(), this.disableContextualWindow();
              }
            }, {
              key: "disableContextualWindow",
              value: function value() {
                window.oncontextmenu = function (e) {
                  if (e.target.classList.contains("hg-button")) return e.preventDefault(), e.stopPropagation(), !1;
                };
              }
            }, {
              key: "processAutoTouchEvents",
              value: function value() {
                this.options.autoUseTouchEvents && (this.options.useTouchEvents = !0, this.options.debug && console.log("autoUseTouchEvents: Touch device detected, useTouchEvents enabled."));
              }
            }, {
              key: "onInit",
              value: function value() {
                this.options.debug && console.log("".concat(this.keyboardDOMClass, " Initialized")), this.setEventListeners(), "function" === typeof this.options.onInit && this.options.onInit();
              }
            }, {
              key: "beforeFirstRender",
              value: function value() {
                this.utilities.isTouchDevice() && this.onTouchDeviceDetected(), "function" === typeof this.options.beforeFirstRender && this.options.beforeFirstRender(), this.isFirstKeyboardInstance && this.utilities.pointerEventsSupported() && !this.options.useTouchEvents && !this.options.useMouseEvents && this.options.debug && console.log("Using PointerEvents as it is supported by this browser"), this.options.useTouchEvents && this.options.debug && console.log("useTouchEvents has been enabled. Only touch events will be used.");
              }
            }, {
              key: "beforeRender",
              value: function value() {
                "function" === typeof this.options.beforeRender && this.options.beforeRender();
              }
            }, {
              key: "onRender",
              value: function value() {
                "function" === typeof this.options.onRender && this.options.onRender();
              }
            }, {
              key: "onModulesLoaded",
              value: function value() {
                "function" === typeof this.options.onModulesLoaded && this.options.onModulesLoaded();
              }
            }, {
              key: "loadModules",
              value: function value() {
                var e = this;
                Array.isArray(this.options.modules) && (this.options.modules.forEach(function (t) {
                  var n = new t();

                  if (n.constructor.name && "Function" !== n.constructor.name) {
                    var o = "module-".concat(e.utilities.camelCase(n.constructor.name));
                    e.keyboardPluginClasses = e.keyboardPluginClasses + " ".concat(o);
                  }

                  n.init(e);
                }), this.keyboardPluginClasses = this.keyboardPluginClasses + " modules-loaded", this.render(), this.onModulesLoaded());
              }
            }, {
              key: "getModuleProp",
              value: function value(e, t) {
                return !!this.modules[e] && this.modules[e][t];
              }
            }, {
              key: "getModulesList",
              value: function value() {
                return Object.keys(this.modules);
              }
            }, {
              key: "parseRowDOMContainers",
              value: function value(e, t, n, o) {
                var r = this,
                    i = Array.from(e.children),
                    s = 0;
                return i.length && n.forEach(function (n, a) {
                  var u = o[a];
                  if (!u || !(u > n)) return !1;
                  var c = n - s,
                      l = u - s,
                      p = document.createElement("div");
                  p.className += "hg-button-container";
                  var f = "".concat(r.options.layoutName, "-r").concat(t, "c").concat(a);
                  p.setAttribute("data-skUID", f);
                  var d = i.splice(c, l - c + 1);
                  s = l - c, d.forEach(function (e) {
                    return p.appendChild(e);
                  }), i.splice(c, 0, p), e.innerHTML = "", i.forEach(function (t) {
                    return e.appendChild(t);
                  }), r.options.debug && console.log("rowDOMContainer", d, c, l, s + 1);
                }), e;
              }
            }, {
              key: "render",
              value: function value() {
                var e = this;
                this.clear(), this.initialized || this.beforeFirstRender(), this.beforeRender();
                var t = "hg-layout-".concat(this.options.layoutName),
                    n = this.options.layout || i.getDefaultLayout(),
                    o = this.options.useTouchEvents || !1,
                    r = o ? "hg-touch-events" : "",
                    s = this.options.useMouseEvents || !1,
                    a = this.options.disableRowButtonContainers;
                this.keyboardDOM.className += " ".concat(this.options.theme, " ").concat(t, " ").concat(this.keyboardPluginClasses, " ").concat(r), n[this.options.layoutName].forEach(function (t, n) {
                  var r = t.split(" "),
                      i = document.createElement("div");
                  i.className += "hg-row";
                  var u = [],
                      c = [];
                  r.forEach(function (t, r) {
                    var l,
                        p = !a && t.includes("[") && t.length > 1,
                        f = !a && t.includes("]") && t.length > 1;
                    p && (u.push(r), t = t.replace(/\[/g, "")), f && (c.push(r), t = t.replace(/\]/g, ""));
                    var d = e.utilities.getButtonClass(t),
                        h = e.utilities.getButtonDisplayName(t, e.options.display, e.options.mergeDisplay),
                        y = e.options.useButtonTag ? "button" : "div",
                        b = document.createElement(y);
                    b.className += "hg-button ".concat(d), (l = b.classList).add.apply(l, _toConsumableArray(e.getButtonThemeClasses(t))), e.setDOMButtonAttributes(t, function (e, t) {
                      b.setAttribute(e, t);
                    }), !e.utilities.pointerEventsSupported() || o || s ? o ? (b.ontouchstart = function (n) {
                      e.handleButtonClicked(t), e.handleButtonMouseDown(t, n);
                    }, b.ontouchend = function () {
                      return e.handleButtonMouseUp(t);
                    }, b.ontouchcancel = function () {
                      return e.handleButtonMouseUp(t);
                    }) : (b.onclick = function () {
                      e.isMouseHold = !1, e.handleButtonClicked(t);
                    }, b.onmousedown = function (n) {
                      return e.handleButtonMouseDown(t, n);
                    }, b.onmouseup = function () {
                      return e.handleButtonMouseUp(t);
                    }) : (b.onpointerdown = function (n) {
                      e.handleButtonClicked(t), e.handleButtonMouseDown(t, n);
                    }, b.onpointerup = function () {
                      return e.handleButtonMouseUp(t);
                    }, b.onpointercancel = function () {
                      return e.handleButtonMouseUp(t);
                    }), b.setAttribute("data-skBtn", t);
                    var m = "".concat(e.options.layoutName, "-r").concat(n, "b").concat(r);
                    b.setAttribute("data-skBtnUID", m);
                    var v = document.createElement("span");
                    v.innerHTML = h, b.appendChild(v), e.buttonElements[t] || (e.buttonElements[t] = []), e.buttonElements[t].push(b), i.appendChild(b);
                  }), i = e.parseRowDOMContainers(i, n, u, c), e.keyboardDOM.appendChild(i);
                }), this.onRender(), this.initialized || (this.initialized = !0, !this.utilities.pointerEventsSupported() || o || s ? o ? (document.ontouchend = function () {
                  return e.handleButtonMouseUp();
                }, document.ontouchcancel = function () {
                  return e.handleButtonMouseUp();
                }) : o || (document.onmouseup = function () {
                  return e.handleButtonMouseUp();
                }) : document.onpointerup = function () {
                  return e.handleButtonMouseUp();
                }, this.onInit());
              }
            }]) && Keyboard_defineProperties(e.prototype, t), SimpleKeyboard;
          }();

          t["default"] = s;
        }]);
      }, "object" === a(t) && "object" === a(e) ? e.exports = s() : (r = [], void 0 === (i = "function" === typeof (o = s) ? o.apply(t, r) : o) || (e.exports = i));
    }).call(this, n(9)(e));
  }, function (e, t, n) {
    e.exports = n(11);
  }, function (e, t, n) {
    "use strict";

    var o = n(1),
        r = n(6),
        i = "function" === typeof Symbol && Symbol["for"],
        s = i ? Symbol["for"]("react.element") : 60103,
        a = i ? Symbol["for"]("react.portal") : 60106,
        u = i ? Symbol["for"]("react.fragment") : 60107,
        c = i ? Symbol["for"]("react.strict_mode") : 60108,
        l = i ? Symbol["for"]("react.profiler") : 60114,
        p = i ? Symbol["for"]("react.provider") : 60109,
        f = i ? Symbol["for"]("react.context") : 60110,
        d = i ? Symbol["for"]("react.forward_ref") : 60112,
        h = i ? Symbol["for"]("react.suspense") : 60113,
        y = i ? Symbol["for"]("react.suspense_list") : 60120,
        b = i ? Symbol["for"]("react.memo") : 60115,
        m = i ? Symbol["for"]("react.lazy") : 60116;
    i && Symbol["for"]("react.fundamental"), i && Symbol["for"]("react.responder");
    var v = "function" === typeof Symbol && Symbol.iterator;

    function A(e) {
      for (var t = e.message, n = "https://reactjs.org/docs/error-decoder.html?invariant=" + t, o = 1; o < arguments.length; o++) {
        n += "&args[]=" + encodeURIComponent(arguments[o]);
      }

      return e.message = "Minified React error #" + t + "; visit " + n + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", e;
    }

    var g = {
      isMounted: function isMounted() {
        return !1;
      },
      enqueueForceUpdate: function enqueueForceUpdate() {},
      enqueueReplaceState: function enqueueReplaceState() {},
      enqueueSetState: function enqueueSetState() {}
    },
        _ = {};

    function D(e, t, n) {
      this.props = e, this.context = t, this.refs = _, this.updater = n || g;
    }

    function E() {}

    function F(e, t, n) {
      this.props = e, this.context = t, this.refs = _, this.updater = n || g;
    }

    D.prototype.isReactComponent = {}, D.prototype.setState = function (e, t) {
      if ("object" !== o(e) && "function" !== typeof e && null != e) throw A(Error(85));
      this.updater.enqueueSetState(this, e, t, "setState");
    }, D.prototype.forceUpdate = function (e) {
      this.updater.enqueueForceUpdate(this, e, "forceUpdate");
    }, E.prototype = D.prototype;
    var k = F.prototype = new E();
    k.constructor = F, r(k, D.prototype), k.isPureReactComponent = !0;
    var w = {
      current: null
    },
        O = {
      suspense: null
    },
        P = {
      current: null
    },
        C = Object.prototype.hasOwnProperty,
        j = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    };

    function M(e, t, n) {
      var o = void 0,
          r = {},
          i = null,
          a = null;
      if (null != t) for (o in void 0 !== t.ref && (a = t.ref), void 0 !== t.key && (i = "" + t.key), t) {
        C.call(t, o) && !j.hasOwnProperty(o) && (r[o] = t[o]);
      }
      var u = arguments.length - 2;
      if (1 === u) r.children = n;else if (1 < u) {
        for (var c = Array(u), l = 0; l < u; l++) {
          c[l] = arguments[l + 2];
        }

        r.children = c;
      }
      if (e && e.defaultProps) for (o in u = e.defaultProps) {
        void 0 === r[o] && (r[o] = u[o]);
      }
      return {
        $$typeof: s,
        type: e,
        key: i,
        ref: a,
        props: r,
        _owner: P.current
      };
    }

    function N(e) {
      return "object" === o(e) && null !== e && e.$$typeof === s;
    }

    var I = /\/+/g,
        K = [];

    function Q(e, t, n, o) {
      if (K.length) {
        var r = K.pop();
        return r.result = e, r.keyPrefix = t, r.func = n, r.context = o, r.count = 0, r;
      }

      return {
        result: e,
        keyPrefix: t,
        func: n,
        context: o,
        count: 0
      };
    }

    function R(e) {
      e.result = null, e.keyPrefix = null, e.func = null, e.context = null, e.count = 0, 10 > K.length && K.push(e);
    }

    function U(e, t, n) {
      return null == e ? 0 : function S(e, t, n, r) {
        var i = o(e);
        "undefined" !== i && "boolean" !== i || (e = null);
        var u = !1;
        if (null === e) u = !0;else switch (i) {
          case "string":
          case "number":
            u = !0;
            break;

          case "object":
            switch (e.$$typeof) {
              case s:
              case a:
                u = !0;
            }

        }
        if (u) return n(r, e, "" === t ? "." + T(e, 0) : t), 1;
        if (u = 0, t = "" === t ? "." : t + ":", Array.isArray(e)) for (var c = 0; c < e.length; c++) {
          var l = t + T(i = e[c], c);
          u += S(i, l, n, r);
        } else if (l = null === e || "object" !== o(e) ? null : "function" === typeof (l = v && e[v] || e["@@iterator"]) ? l : null, "function" === typeof l) for (e = l.call(e), c = 0; !(i = e.next()).done;) {
          u += S(i = i.value, l = t + T(i, c++), n, r);
        } else if ("object" === i) throw n = "" + e, A(Error(31), "[object Object]" === n ? "object with keys {" + Object.keys(e).join(", ") + "}" : n, "");
        return u;
      }(e, "", t, n);
    }

    function T(e, t) {
      return "object" === o(e) && null !== e && null != e.key ? function (e) {
        var t = {
          "=": "=0",
          ":": "=2"
        };
        return "$" + ("" + e).replace(/[=:]/g, function (e) {
          return t[e];
        });
      }(e.key) : t.toString(36);
    }

    function ea(e, t) {
      e.func.call(e.context, t, e.count++);
    }

    function fa(e, t, n) {
      var o = e.result,
          r = e.keyPrefix;
      e = e.func.call(e.context, t, e.count++), Array.isArray(e) ? V(e, o, n, function (e) {
        return e;
      }) : null != e && (N(e) && (e = function (e, t) {
        return {
          $$typeof: s,
          type: e.type,
          key: t,
          ref: e.ref,
          props: e.props,
          _owner: e._owner
        };
      }(e, r + (!e.key || t && t.key === e.key ? "" : ("" + e.key).replace(I, "$&/") + "/") + n)), o.push(e));
    }

    function V(e, t, n, o, r) {
      var i = "";
      null != n && (i = ("" + n).replace(I, "$&/") + "/"), U(e, fa, t = Q(t, i, o, r)), R(t);
    }

    function W() {
      var e = w.current;
      if (null === e) throw A(Error(321));
      return e;
    }

    var x = {
      Children: {
        map: function map(e, t, n) {
          if (null == e) return e;
          var o = [];
          return V(e, o, null, t, n), o;
        },
        forEach: function forEach(e, t, n) {
          if (null == e) return e;
          U(e, ea, t = Q(null, null, t, n)), R(t);
        },
        count: function count(e) {
          return U(e, function () {
            return null;
          }, null);
        },
        toArray: function toArray(e) {
          var t = [];
          return V(e, t, null, function (e) {
            return e;
          }), t;
        },
        only: function only(e) {
          if (!N(e)) throw A(Error(143));
          return e;
        }
      },
      createRef: function createRef() {
        return {
          current: null
        };
      },
      Component: D,
      PureComponent: F,
      createContext: function createContext(e, t) {
        return void 0 === t && (t = null), (e = {
          $$typeof: f,
          _calculateChangedBits: t,
          _currentValue: e,
          _currentValue2: e,
          _threadCount: 0,
          Provider: null,
          Consumer: null
        }).Provider = {
          $$typeof: p,
          _context: e
        }, e.Consumer = e;
      },
      forwardRef: function forwardRef(e) {
        return {
          $$typeof: d,
          render: e
        };
      },
      lazy: function lazy(e) {
        return {
          $$typeof: m,
          _ctor: e,
          _status: -1,
          _result: null
        };
      },
      memo: function memo(e, t) {
        return {
          $$typeof: b,
          type: e,
          compare: void 0 === t ? null : t
        };
      },
      useCallback: function useCallback(e, t) {
        return W().useCallback(e, t);
      },
      useContext: function useContext(e, t) {
        return W().useContext(e, t);
      },
      useEffect: function useEffect(e, t) {
        return W().useEffect(e, t);
      },
      useImperativeHandle: function useImperativeHandle(e, t, n) {
        return W().useImperativeHandle(e, t, n);
      },
      useDebugValue: function useDebugValue() {},
      useLayoutEffect: function useLayoutEffect(e, t) {
        return W().useLayoutEffect(e, t);
      },
      useMemo: function useMemo(e, t) {
        return W().useMemo(e, t);
      },
      useReducer: function useReducer(e, t, n) {
        return W().useReducer(e, t, n);
      },
      useRef: function useRef(e) {
        return W().useRef(e);
      },
      useState: function useState(e) {
        return W().useState(e);
      },
      Fragment: u,
      Profiler: l,
      StrictMode: c,
      Suspense: h,
      unstable_SuspenseList: y,
      createElement: M,
      cloneElement: function cloneElement(e, t, n) {
        if (null === e || void 0 === e) throw A(Error(267), e);
        var o = void 0,
            i = r({}, e.props),
            a = e.key,
            u = e.ref,
            c = e._owner;

        if (null != t) {
          void 0 !== t.ref && (u = t.ref, c = P.current), void 0 !== t.key && (a = "" + t.key);
          var l = void 0;

          for (o in e.type && e.type.defaultProps && (l = e.type.defaultProps), t) {
            C.call(t, o) && !j.hasOwnProperty(o) && (i[o] = void 0 === t[o] && void 0 !== l ? l[o] : t[o]);
          }
        }

        if (1 === (o = arguments.length - 2)) i.children = n;else if (1 < o) {
          l = Array(o);

          for (var p = 0; p < o; p++) {
            l[p] = arguments[p + 2];
          }

          i.children = l;
        }
        return {
          $$typeof: s,
          type: e.type,
          key: a,
          ref: u,
          props: i,
          _owner: c
        };
      },
      createFactory: function createFactory(e) {
        var t = M.bind(null, e);
        return t.type = e, t;
      },
      isValidElement: N,
      version: "16.9.0",
      unstable_withSuspenseConfig: function unstable_withSuspenseConfig(e, t) {
        var n = O.suspense;
        O.suspense = void 0 === t ? null : t;

        try {
          e();
        } finally {
          O.suspense = n;
        }
      },
      __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
        ReactCurrentDispatcher: w,
        ReactCurrentBatchConfig: O,
        ReactCurrentOwner: P,
        IsSomeRendererActing: {
          current: !1
        },
        assign: r
      }
    },
        B = {
      "default": x
    },
        L = B && x || B;
    e.exports = L["default"] || L;
  }, function (e, t, n) {
    "use strict";

    var o = Object.getOwnPropertySymbols,
        r = Object.prototype.hasOwnProperty,
        i = Object.prototype.propertyIsEnumerable;

    function toObject(e) {
      if (null === e || void 0 === e) throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(e);
    }

    e.exports = function () {
      try {
        if (!Object.assign) return !1;
        var e = new String("abc");
        if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

        for (var t = {}, n = 0; n < 10; n++) {
          t["_" + String.fromCharCode(n)] = n;
        }

        if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
          return t[e];
        }).join("")) return !1;
        var o = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (e) {
          o[e] = e;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, o)).join("");
      } catch (r) {
        return !1;
      }
    }() ? Object.assign : function (e, t) {
      for (var n, s, a = toObject(e), u = 1; u < arguments.length; u++) {
        for (var c in n = Object(arguments[u])) {
          r.call(n, c) && (a[c] = n[c]);
        }

        if (o) {
          s = o(n);

          for (var l = 0; l < s.length; l++) {
            i.call(n, s[l]) && (a[s[l]] = n[s[l]]);
          }
        }
      }

      return a;
    };
  }, function (e, t, n) {
    "use strict";

    var o = n(8);

    function emptyFunction() {}

    function emptyFunctionWithReset() {}

    emptyFunctionWithReset.resetWarningCache = emptyFunction, e.exports = function () {
      function shim(e, t, n, r, i, s) {
        if (s !== o) {
          var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw a.name = "Invariant Violation", a;
        }
      }

      function getShim() {
        return shim;
      }

      shim.isRequired = shim;
      var e = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      return e.PropTypes = e, e;
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t) {
    e.exports = function (e) {
      return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
        enumerable: !0,
        get: function get() {
          return e.l;
        }
      }), Object.defineProperty(e, "id", {
        enumerable: !0,
        get: function get() {
          return e.i;
        }
      }), e.webpackPolyfill = 1), e;
    };
  }, function (e, t, n) {}, function (e, t, n) {
    "use strict";

    n.r(t);
    var o = n(0),
        r = n.n(o),
        i = n(2),
        s = n.n(i),
        a = n(3),
        u = n.n(a);

    function ownKeys(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t && (o = o.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, o);
      }

      return n;
    }

    function _defineProperty(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    var c = function c(e) {
      return function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? ownKeys(n, !0).forEach(function (t) {
            _defineProperty(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ownKeys(n).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }

        return e;
      }({}, e, {
        theme: "simple-keyboard ".concat(e.theme || "hg-theme-default")
      });
    };

    n(10);

    function _typeof(e) {
      return (_typeof = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function Keyboard_ownKeys(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t && (o = o.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, o);
      }

      return n;
    }

    function _defineProperties(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }

    function _getPrototypeOf(e) {
      return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function _assertThisInitialized(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function _setPrototypeOf(e, t) {
      return (_setPrototypeOf = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Keyboard_defineProperty(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    var l = function (e) {
      function KeyboardReact() {
        var e, t, n, o;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, KeyboardReact);

        for (var r = arguments.length, i = new Array(r), s = 0; s < r; s++) {
          i[s] = arguments[s];
        }

        return n = this, o = (e = _getPrototypeOf(KeyboardReact)).call.apply(e, [this].concat(i)), t = !o || "object" !== _typeof(o) && "function" !== typeof o ? _assertThisInitialized(n) : o, Keyboard_defineProperty(_assertThisInitialized(t), "baseClassDefault", "react-simple-keyboard"), Keyboard_defineProperty(_assertThisInitialized(t), "componentDidMount", function () {
          var e = _assertThisInitialized(t),
              n = e.props,
              o = (0, e.getCssBaseClass)();

          t.keyboard = new u.a(".".concat(o), function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? Keyboard_ownKeys(n, !0).forEach(function (t) {
                Keyboard_defineProperty(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Keyboard_ownKeys(n).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }

            return e;
          }({}, c(n)));
        }), Keyboard_defineProperty(_assertThisInitialized(t), "componentWillReceiveProps", function (e) {
          return t.keyboard.setOptions(c(e));
        }), Keyboard_defineProperty(_assertThisInitialized(t), "getCssBaseClass", function () {
          return t.props.baseClass || t.baseClassDefault;
        }), t;
      }

      var t, n, i;
      return function (e, t) {
        if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && _setPrototypeOf(e, t);
      }(KeyboardReact, o["Component"]), t = KeyboardReact, (n = [{
        key: "shouldComponentUpdate",
        value: function value(e, t) {
          return this.props.stateToIgnore === e.stateToIgnore;
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.getCssBaseClass;
          return r.a.createElement("div", {
            className: "".concat(e())
          });
        }
      }]) && _defineProperties(t.prototype, n), i && _defineProperties(t, i), KeyboardReact;
    }();

    l.propTypes = {
      stateToIgnore: s.a.any
    };
    var p = l;
    t["default"] = p;
  }]);
});